// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import { Field } from 'redux-form'
import MatchRowCheckbox from './MatchRowCheckbox'
import SegmentEndInfo from './SegmentEndInfo'

const MatchRow = ({ checkboxGroupName, idRoot, segmentEndData }) => (
  <tr>
    <Field
      component={MatchRowCheckbox}
      id={`${idRoot}-checkbox`}
      name={checkboxGroupName}
      segmentEndId={segmentEndData.segmentEndId} />
    <SegmentEndInfo
      idRoot={idRoot}
      segmentEndData={segmentEndData} />
  </tr>
)

MatchRow.propTypes = {
  checkboxGroupName: string.isRequired,
  idRoot: string.isRequired,
  segmentEndData: object.isRequired,
}

export default MatchRow
